import './index.scss'
import { HTMLAttributes } from 'react'
import React from 'react'
import clsx from 'clsx'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
	transperentBackground?: boolean
}

export function Card({ transperentBackground, className, ...rest }: CardProps) {
	return (
		<div
			className={clsx(
				'cardd',
				className,
				transperentBackground && 'cardd--transparent',
			)}
			{...rest}
		/>
	)
}

export function CardHeader({
	className,
	...rest
}: HTMLAttributes<HTMLDivElement>) {
	return <div className={clsx('cardd-header', className)} {...rest} />
}

export function CardContent({
	className,
	...rest
}: HTMLAttributes<HTMLDivElement>) {
	return <div className={clsx('cardd-content', className)} {...rest} />
}

export function CardFooter({
	className,
	...rest
}: HTMLAttributes<HTMLDivElement>) {
	return <div className={clsx('cardd-footer', className)} {...rest} />
}

export function CardInfoContainer({
	className,
	...rest
}: HTMLAttributes<HTMLDivElement>) {
	return <div className={clsx('cardd-info-container', className)} {...rest} />
}
export function CardInfoTitle({
	className,
	...rest
}: HTMLAttributes<HTMLDivElement>) {
	return <div className={clsx('cardd-info-title', className)} {...rest} />
}
export function CardInfo({
	className,
	...rest
}: HTMLAttributes<HTMLDivElement>) {
	return <div className={clsx('cardd-info', className)} {...rest} />
}
export function CardInfoLabel({
	className,
	...rest
}: HTMLAttributes<HTMLSpanElement>) {
	return <span className={clsx('cardd-info-label', className)} {...rest} />
}
export function CardInfoValue({
	className,
	...rest
}: HTMLAttributes<HTMLSpanElement>) {
	return <span className={clsx('cardd-info-value', className)} {...rest} />
}

Card.Header = CardHeader
Card.Content = CardContent
Card.Footer = CardFooter

Card.InfoContainer = CardInfoContainer
Card.InfoTitle = CardInfoTitle
Card.Info = CardInfo
Card.InfoLabel = CardInfoLabel
Card.InfoValue = CardInfoValue
